import { cn } from '@/lib/utils'

interface StatCardProps {
  title: string
  subtitle?: string
  children: React.ReactNode
  className?: string
}

export function StatCard({ title, subtitle, children, className }: StatCardProps) {
  return (
    <div className={cn('rounded-lg border bg-card p-6', className)}>
      <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
      <div className="mt-2">{children}</div>
      {subtitle && <p className="mt-1 text-xs text-muted-foreground">{subtitle}</p>}
    </div>
  )
}

interface ProgressBarProps {
  matched: number
  total: number
}

export function ProgressBar({ matched, total }: ProgressBarProps) {
  const pct = total > 0 ? ((matched / total) * 100).toFixed(1) : '0.0'
  return (
    <div>
      <div className="text-2xl font-bold tracking-tight">
        {matched}
        <span className="text-base font-normal text-muted-foreground">/{total}</span>
        <span className="ml-2 text-sm font-normal text-muted-foreground">({pct}%)</span>
      </div>
      <div className="mt-2 h-2 w-full rounded-full bg-secondary">
        <div className="h-2 rounded-full bg-primary transition-all" style={{ width: `${pct}%` }} />
      </div>
    </div>
  )
}
